import { jwtDecode } from "jwt-decode";
import { JWT } from "./types";

export const getJwtFromToken = (token: string | null) => (token ? jwtDecode<JWT>(token) : null);
export const getJwtExpiration = (jwt: JWT | null) => jwt && new Date(jwt.exp * 1000);
export const getJwtIsExpired = (jwt: JWT | null) => {
  const expiration = getJwtExpiration(jwt);
  return expiration && expiration < new Date();
};
